import { useState, useCallback } from "react";

const STORAGE_KEY_PREFIX = "wondermaps_welcomed_";

/**
 * Hook to track first-time visits per organization.
 * Uses localStorage to persist welcome modal dismissal.
 */
export function useFirstVisit(orgSlug: string) {
  const storageKey = `${STORAGE_KEY_PREFIX}${orgSlug}`;

  const [isFirstVisit] = useState(() => {
    if (typeof window === "undefined") return true;
    return localStorage.getItem(storageKey) !== "true";
  });

  const markVisited = useCallback(() => {
    if (typeof window === "undefined") return;
    localStorage.setItem(storageKey, "true");
  }, [storageKey]);

  return { isFirstVisit, markVisited };
}
